import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import ReportFiltersCommon from './report-filters-common';
import UrlMixin from '@/components/query/url-mixin';

import { pushURL } from '@/views/reports/pickers/base/utils';
import { pushURL as pushURLConversions } from '@/views/reports/pickers/base/conversions/utils';
import { pushURL as pushURLPostbacks } from '@/views/reports/pickers/base/postbacks/utils';
import { pushURL as pushURLErrors } from '@/views/reports/pickers/base/errors/utils';
import { pushURL as pushURLLiveVisits } from '@/views/reports/pickers/base/live-visits/utils';
import { pushURL as pushURLLiveClicks } from '@/views/reports/pickers/base/live-clicks/utils';


@Component
export default class ReportFilters extends mixins(ReportFiltersCommon, UrlMixin) {
  filtersActive: boolean = false;

  sorting_filters: any = {
    descending: true,
    totalItems: 50,
    rowsPerPage: 50,
    page: 1
  };

  get sortingParams() {
    const { name } = this.$route;

    switch(name) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return {
          sortBy: this.$store.getters.reportParams.orderBy,
          descending: this.$store.getters.reportParams.orderDir,
        };

      default:
        const filters = this.getFilters();

        return {
          sortBy: filters.orderBy,
          descending: filters.orderDir === 'desc'
        }
    }
  }

  setSorting() {
    const { sortBy, descending } = this.sortingParams;

    this.sorting_filters.sortBy = sortBy;
    this.sorting_filters.descending = descending;
  }

  beforeMount() {
    if(
        !this.isDashbord
        //@ts-ignore
        && !this.subReport
      ) {
        this.$filter.promise.then(() => {
          this.filtersActive = true;
          
          this.setSorting();
          this.$filter.clear();
        });
    } 
  }

  pushURL() {
    const { name } = this.$route;

    switch(name) {     
      case 'app.conversions':
        return pushURLConversions(this);
      case 'app.postbacks':
        return pushURLPostbacks(this);
      case 'app.errors':
        return pushURLErrors(this);
      case 'app.live-visits':
        return pushURLLiveVisits(this);
      case 'app.live-clicks':
        return pushURLLiveClicks(this);

      default:
        return pushURL(this);
    }
  }

}
